
const requireContext = require.context('./langs', true, /index.js$/)
const messages = requireContext.keys().reduce((pre, current) => {
    const name = current.split("/")[1];
    return Object.assign(pre, {
        [name]: requireContext(current).default, //同步
    })
}, {})

export default messages


// WEBPACK FOOTER //
// ./src/i18n/index.js